theme.Currency = (function(){
  var moneyFormat = $('#shop_currency_val').attr('data-value');
  function formatMoney(cents, format){
    if(typeof cents === 'string'){
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);
    function formatWithDelimiters(number, precision, thousands, decimal){
      precision = precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if(isNaN(number) || number == null){
        return 0;
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';
      return dollarsAmount + centsAmount;
    }
    switch(formatString.match(placeholderRegex)[1]){
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  }
})();

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $){
  var shop_currency = $('#shop_currency_val').attr('data-value');

  'use strict';
  var init, loadCart;
  var settings, isUpdating, $body;
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, validateQty;

  init = function(options){
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#cart_container_id',
      addToCartSelector  : 'button[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : shop_currency,
      disableAjaxCart    : false,
      enableQtySelectors : false
    };
    $.extend(settings, options);
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);
    $body = $('body');
    isUpdating = false;
    if(!settings.disableAjaxCart && $addToCart.length){
      formOverride();
    }
    adjustCart();
  };
  loadCart = function(){
    wc_theme_source.lib.get_cart(cartUpdateCallback);
  };
  updateCountPrice = function(cart){
    if($cartCountSelector){
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');
      if(cart.item_count === 0){
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if($cartCostSelector){
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, ''));
                                                 }
                                                 };
                                                 formOverride = function(){
                             $formContainer.on('submit', function(evt){
        evt.preventDefault();
        wc_theme_source.lib.addtocart_form(evt.target, itemAddedCallback, itemErrorCallback)
      });
    };
    itemAddedCallback = function(product){
      wc_theme_source.lib.get_cart(cartUpdateCallback);
    };
    itemErrorCallback = function(XMLHttpRequest, textStatus){
      var data = eval('(' + XMLHttpRequest.responseText + ')');
      $addToCart.removeClass('is-adding is-added');
      if(!!data.message){
        if(data.status == 422){
          $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
        }
      }
    };
    cartUpdateCallback = function(cart){
      updateCountPrice(cart);
      buildCart(cart);
      

    };
    buildCart = function(cart){
      $cartContainer.empty();
      
      if(cart.item_count === 0){
        $cartContainer.append('<div class="wf-wrap"><div class="empty_cart_image_cls"><img src="//cdn.shopify.com/s/files/1/0042/3303/5825/t/101/assets/cart-empty.jpg?v=9630481699362386360" alt="empty cart" alt="empty_cart_image" ></div><h5 class="empty_cart_slide_cls">' + "Your cart is currently empty." + '</h5></div>');
        cartCallback(cart);
        return;
      }
      var items = [], item = {}, data = {}, source = $("#CartTemplate").html(), template = Handlebars.compile(source);
      $.each(cart.items, function(index, cartItem){
        if(cartItem.image != null){
          var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
        } else{
          var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
        }
        if(cartItem.properties !== null){
          $.each(cartItem.properties, function(key, value){
            if(key.charAt(0) === '_' || !value){
              delete cartItem.properties[key];
            }
          });
        }
        var freeclass ="";
        if(cartItem.id == $('.free_gift_id').attr('data-id')){
          freeclass= "freegift";
        }
        else{
          freeclass = "";
        }
        
        var freesoap = '';
        if(cartItem.id == $('.free_soap_id').attr('data-id')){
          freesoap = 'freeSoapPro';
        }else{
          freesoap = '';
        }
        
        var show_quantity = true;
        var prd_type = cartItem.product_type.toLowerCase().replace(/ /g,'-');
        if (prd_type == 'sample-product')
        {
        	var show_quantity = false;  
        }
        item = {
          key: cartItem.key,
          line: index + 1,
          url: cartItem.url,
          img: prodImg,
          itemid:cartItem.id,
          freeclass:freeclass,
          freesoap: freesoap,
          name: cartItem.product_title,
          variation: cartItem.variant_title,
          properties: cartItem.properties,
          itemAdd: cartItem.quantity + 1,
          itemMinus: cartItem.quantity - 1,
          itemQty: cartItem.quantity,
          price: Shopify.formatMoney(cartItem.price, shop_currency),
          final_price: Shopify.formatMoney(cartItem.final_line_price, shop_currency),
          discountedPrice: Shopify.formatMoney((cartItem.price - (cartItem.total_discount/cartItem.quantity)), shop_currency) ,
          discounts: cartItem.discounts,
          discountsApplied: cartItem.price === (cartItem.price - cartItem.total_discount) ? false : true,
          vendor: cartItem.vendor,
          show_quantity: show_quantity
        };
        items.push(item);
      });
      data = {
        items: items,
        note: cart.note,
        totalPrice: Shopify.formatMoney(cart.total_price, shop_currency),
        totalCartDiscount: cart.total_discount === 0 ? 0 : "translation missing: en.cart.general.savings_html".replace('[savings]', theme.Currency.formatMoney(cart.total_discount, settings.moneyFormat))
      };
      $cartContainer.append(template(data));
      cartCallback(cart);

      function check_upsell_code(){
        var upsell_array = new Array();
        $('#wc_cart_drawer_upsell .wc_upsell_grid').each(function(index){
          var upsell_this = $(this);
          console.log(upsell_this);
          var upsell_handle = upsell_this.data('upsell');
          if(jQuery.inArray(upsell_handle, upsell_array) != -1){
            upsell_this.remove();
          } else{
            upsell_array.push(upsell_handle);
            /*StampedFn.loadBadges();*/
          } 
        });
        jQuery.getJSON('/cart.js', function(cart){
          /*if(cart.total_price < 10000){
          var remain_totla = (10000 - cart.total_price) / 100;
          $('#CartContainer .wc_cart_discount .remain_disc').text('+'+remain_totla);
          $('#CartContainer .wc_cart_discount .cart_remain').text('+'+remain_totla);
          $('#CartContainer .wc_cart_discount .wc_cart_progress').css('width',100-remain_totla+'%');

        } else{
          $('#CartContainer .wc_cart_discount').html('<span class="free_shipping_lable">Free Shipping is available</span>');
        }*/
          $.each(cart.items, function(key, val){
            $('#wc_cart_drawer_upsell .wc_upsell_grid').each(function(index){
              var upsell_this = $(this);
              var upsell_handle = upsell_this.data('upsell');
              if(val.handle == upsell_handle){
                upsell_this.remove();
                //console.log('remove');
                setTimeout(function(){
                  if($('.upsell_content ul.ajax-cart-upsell-slider li').length > 1){
                    $('#wc_cart_drawer_upsell .ajax-cart-upsell-slider').slick({
                      slidesToShow:1,
                      slidesToScroll: 1,
                      infinite: false,
                      dots: false,
                      arrows: true,
                      variableWidth: false,
                      slide: 'li'
                    });
                  }
                }, 150);
              }else{
                if($('.upsell_content ul.ajax-cart-upsell-slider li').length > 1){
                  $('#wc_cart_drawer_upsell .ajax-cart-upsell-slider').slick({
                    slidesToShow:1,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: false,
                    arrows: true,
                    variableWidth: false,
                    slide: 'li'
                  });
                }
              }
            });
            setTimeout(function(){

            },1000);
            if(key === cart.items.length - 1){
              //console.log('in');
              if($('.cart-side-panel .wc_upsell_grid').length < 1){
                $('.cart-side-panel .upsell_content').remove();
              }
              $('.upsell_content').show();
            }
          });
        });
      }

      var upsell_final_html = '';
      jQuery.getJSON('/cart.js', function(cart){
        var upsell_show = false;
        if(cart.total_price < 10000){
          var remain_totla = (10000 - cart.total_price) / 100;
          $('#CartContainer .wc_cart_discount .remain_disc').text('+'+remain_totla);
          $('#CartContainer .wc_cart_discount .cart_remain').text('+'+remain_totla);
          $('#CartContainer .wc_cart_discount .wc_cart_progress').css('width',100-remain_totla+'%');
        } else{
          $('#CartContainer .wc_cart_discount').html('<span class="free_shipping_lable">Free Shipping is available</span>');
        }
        $.each(cart.items, function(key, val){
          var upsell_local_val = 'upsell-handle'+val.handle;           
          if(localStorage.getItem(upsell_local_val) != null && localStorage.getItem(upsell_local_val) != ''){
            var upsell_local_html = localStorage.getItem(upsell_local_val);
            upsell_final_html += upsell_local_html;
            upsell_show = true;
          }
          if(key === cart.items.length - 1){
            if(upsell_show){
              $('#wc_cart_drawer_upsell').append(upsell_final_html);
              check_upsell_code();
            }
          }
        });
      });
      
/*=== cart drawer - soap product  ===*/
      var temp_variant_id = $('.free_soap_id').attr('data-id');
      var soapProPrice = $('.free_soap_id').attr('data-price');
      var finalTotal = cart.total_price - soapProPrice;
      var freeSoapProMinAmount = 50000000;
      if(cart.total_price >= freeSoapProMinAmount){
        if($('.items_row.freeSoapPro').length < 1){
          var temp_qty = 1;
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: "quantity=" + temp_qty + "&id=" + temp_variant_id,
            dataType: "json",
            success: function(item){
              ajaxCart.load();
            },
            error: function(XMLHttpRequest, textStatus){
              wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
            }
          });
        }
      }else{
        if($('.items_row.freeSoapPro').length > 0){
          $('.items_row.freeSoapPro').find('.cart_remove_item').trigger('click');
        }
      }
/*=== end cart drawer - soap product  ===*/
 
      $('#wc_cart_drawer_upsell').load('/pages/upsell' + ' #ajax-cart-sample', function(){
        window.history.pushState({}, null);
          if($('.upsell_content ul.ajax-cart-upsell-slider li').length > 1){
            $('#wc_cart_drawer_upsell .ajax-cart-upsell-slider').slick({
              slidesToShow:1,
              slidesToScroll: 1,
              infinite: false,
              dots: false,
              arrows: true,
              variableWidth: false,
              slide: 'li'
            });
          }
      });
      
      
     
    };

    cartCallback = function(cart){
      $body.trigger('ajaxCart.afterCartLoad', cart);
      wc_theme_source.lib.on_cart_update(cart);
      if(window.Shopify && Shopify.StorefrontExpressButtons){
        Shopify.StorefrontExpressButtons.initialize();
      }
    };

    adjustCart = function(){
      $body.on('click', '.ajaxcart__qty-adjust', function(){
        if(isUpdating){
          return;
        }
        var $el = $(this), line = $el.data('line'), $qtySelector = $el.parents('ul.QuantityBox').find('.ajaxcart__qty-num'), qty = parseInt($qtySelector.val());
        var qty = validateQty(qty);
        if($el.hasClass('ajaxcart__qty--plus')){
          qty += 1;
        } else{
          qty -= 1;
          if(qty <= 0) qty = 0;
        }
        if(line){
          updateQuantity(line, qty);
        } else{
          $qtySelector.val(qty);
        }
      });

      $body.on('click', '.cart_remove_item', function(){
        var line = $(this).attr('data-line');
        wc_theme_source.lib.cart_remove_item(line, adjustCartCallback)
      });
      $body.on('change', '.ajaxcart__qty-num', function(){
        if(isUpdating){
          return;
        }
        var $el = $(this), line = $el.data('line'), qty = parseInt($el.val().replace(/\D/g, ''));
        var qty = validateQty(qty);
        if(line){
          updateQuantity(line, qty);
        }
      });
      $body.on('submit', 'form.ajaxcart', function(evt){
        if(isUpdating){
          evt.preventDefault();
        }
      });
      $body.on('focus', '.ajaxcart__qty-adjust', function(){
        var $el = $(this);
        setTimeout(function(){
          $el.select();
        }, 50);
      });
      function updateQuantity(line, qty){
        isUpdating = true;
        var $row = $('.Quantity_cart_slider[data-line="' + line + '"]').addClass('is-loading');
        if(qty === 0){
          $row.parent().addClass('is-removed');
        }
        setTimeout(function(){
          wc_theme_source.lib.cart_change_item(line, qty, adjustCartCallback);
        }, 250);
      }
    };
    adjustCartCallback = function(cart){
      updateCountPrice(cart);
      setTimeout(function(){
        wc_theme_source.lib.get_cart(buildCart);
        isUpdating = false;
      }, 150)
    };
    validateQty = function(qty){
      if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)){} else{
        qty = 1;
      }
      return qty;
    };
    module = {
      init: init,
      load: loadCart
    };
    return module;
  }(ajaxCart || {}, jQuery));

  

/*=== cart page - soap product  ===*/
  function myTimer() {
    setTimeout(function(){
      $('.cart-upsell-slider').slick({
        slidesToShow:2,
        slidesToScroll: 1,
        infinite: false,
        dots: false,
        arrows: true,
        variableWidth: true,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              variableWidth: false,
              infinite:true,
              adaptiveHeight: true
            }
          },
          {
            breakpoint: 641,
            settings: {
              variableWidth: false,
              slidesToShow:1,
              infinite:true,
              adaptiveHeight: true
            }
          }
        ]
      });
    }, 2000);
  }  
  $('.cart_loader').show();
  $('.cart-form-wrap').hide();
  $(window).on('load',function(){
    $('.cart_loader').show();
    $('.cart-form-wrap').hide();
    var cartTotal = ($('.subtotal_cls').find('.footer-row-right').text()).replace(/[$.]/g,'');
    var soapProPrice = $('.free_soap_id').attr('data-price');
    var finalTotal =  cartTotal - soapProPrice;
    var soapID = $('.free_soap_id').attr('data-id');
    var qty = 1;  
    var soapProMinAmount = 50000000;
    if(cartTotal >= soapProMinAmount && $('.cart-item-cls.cartSoapProduct').length < 1){
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: "quantity=" + qty + "&id=" + soapID,
        dataType: "json",
        beforeSend: function(){
          $('.cart_loader').show();
          $('.cart-form-wrap').hide();
        },
        success: function(item){
          var url  = window.location.href;
          $('.cart_load_block').load(url + ' .cart_load_block .cart-page-form', function(){
            window.history.pushState({}, null, url);  
          });
        },
        error: function(XMLHttpRequest, textStatus){
          wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
        },
        complete: function(){
          console.log('success----------');
          $('.cart_loader').hide();
          $('.cart-form-wrap').show();
          myTimer();
        }
      });
    }else if(finalTotal < soapProMinAmount && $('.cart-item-cls.cartSoapProduct').length >= 1){
      var dataIndex = $('.cart-item-cls.cartSoapProduct').attr('data-index');
      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=0&line=" + dataIndex,
        dataType: "json",
        beforeSend: function(){
          $('.cart_loader').show();
          $('.cart-form-wrap').hide();
        },
        success: function(item){
          var url  = window.location.href;
          $('.cart_load_block').load(url + ' .cart_load_block .cart-page-form', function(){
            window.history.pushState({}, null, url);  
          });
        },
        error: function(XMLHttpRequest, textStatus){
          wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
        },
        complete: function(){
          console.log('success----------');
          $('.cart_loader').hide();
          $('.cart-form-wrap').show();
          myTimer();
        }
      });
    }else{
      console.log('success----------');
      $('.cart_loader').hide();
      $('.cart-form-wrap').show();
      myTimer();    
    }
  });
/*=== end cart page - soap product  ===*/
  
  var shop_currency_default = $('#shop_currency_val').attr('data-value');
  function myCartSection() {
    var SideContentHeight = $('.block-cart-header').innerHeight() + $('.block-cart-footer').innerHeight() + $('.shoppinggives_wrap_in').innerHeight();
    $('#cart_container_id .cart-middle-items').css('height', $(window).height() - SideContentHeight + 'px');
  }
  $("#cart_container_id").bind("DOMSubtreeModified", function() {
    myCartSection();
  });
  jQuery(window).resize(function(){
    myCartSection();
  });

  var shop_currency = shop_currency_default;;
  var free_shippping_amount = Number(25) * 100;
  var wc_theme_source = {
    lib:{
      ajax_error: function(error, message){
        var data = eval('('+error.responseText+')');
        if (!!data.message) {
          $('#added_product_popup').find('h3').text(data.description);
          $('#added_product_popup').find('.cart_redirect_btn').hide();
          $('#added_product_popup').show("clip", 500);
        }
      },
      on_cart_update: function(item){
        setTimeout(function(){
          jQuery.getJSON('/cart.js', function(cart) {
            $('.cart_qty_cls').html(cart.item_count);
            if(cart.item_count > 0){
              var cart_price = Shopify.formatMoney(cart.total_price, shop_currency_default);
              if($('.items_carts span').hasClass('money')){
                $('.items_carts span').remove();
                $('.items_carts').html("<span class='money'>"+cart_price+"</span>");
              } else{
                $('.items_carts').html("<span class='money'>"+cart_price+"</span>");
              }
            } else{
              $('.items_carts span').remove();
              $('.items_carts').html("<span class='money'>$0.00</span>");
            }
            setTimeout(function(){            
              myCartSection();
            },1000);
            if(free_shippping_amount != '' || free_shippping_amount != null || free_shippping_amount != undefined){
              var cartTotal = cart.total_price;
              if(cartTotal < free_shippping_amount){
                var remain_totla = (free_shippping_amount - cartTotal);
                var remain_totla = Shopify.formatMoney(remain_totla, shop_currency_default);              
                $('#cart_container_id .cart-free-shipping-wrap').html('<p>You’re '+remain_totla+' away from free shipping!</p>');
              } else{
                $('#cart_container_id .cart-free-shipping-wrap').html('<p>Free Shipping is available</p>');
              }
            }
          });
        },100);
      },
      on_item_added: function(item){

        ajaxCart.load();
      },
      on_product: function(e){
        alert("Received everything we ever wanted to know about " + e.title);
      },
      addtocart_product: function(id, qty, callback){
        var qty = qty || 1;
        var ajax = {
          type: "POST",
          url: "/cart/add.js",
          data: "quantity=" + qty + "&id=" + id,
          dataType: "json",
          success: function(item){
            if((typeof callback) === 'function'){
              callback(item, id);
            }else{
              wc_theme_source.lib.on_item_added(item);
            }
          },
          error: function(XMLHttpRequest, textStatus){
            wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
          }
        };
        jQuery.ajax(ajax);
      },
      get_product: function(handle, callback){
        jQuery.getJSON("/products/" + handle + ".js", function(product, n){
          wc_theme_source.lib.on_product(product);
        });
      },
      get_cart: function(callback){
        jQuery.getJSON("/cart.js", function(cart, textstatus){
          if((typeof callback) === 'function'){
            callback(cart);
          } else{
            wc_theme_source.lib.on_cart_update(cart);
          }
        });
      },
      addtocart_form: function(form_id, callback, errorCallback, this_click){
        var ajax = {
          type: 'POST',
          url: '/cart/add.js',
          data: jQuery('#' + form_id).serialize(),
          dataType: 'json',
          beforeSend: function(){
            jQuery('#'+form_id).find(".cart_btn_class").attr("disabled", true);
          },
          success: function(item){
            if((typeof callback) === 'function'){
              callback(item, form_id);
            } else{
              jQuery.getJSON("/cart.js", function(cart){

              });
              wc_theme_source.lib.on_item_added(item);
            }
            setTimeout(function(){


              $('body').addClass('CartOpen');

            },500);
          },
          error: function(XMLHttpRequest, textStatus){
            if((typeof errorCallback) === 'function'){
              errorCallback(XMLHttpRequest, textStatus);
            } else{
              wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus, this_click);
            }
          }
        };
        jQuery.ajax(ajax);
      },
      cart_change_item: function(line, qty, callback){
        var ajax = {
          type: 'POST',
          url: '/cart/change.js',
          data: 'quantity=' + qty + '&line=' + line,
          dataType: 'json',
          success: function(cart){
            if((typeof callback) === 'function'){
              callback(cart);
            } else{
              wc_theme_source.lib.on_cart_update(cart);
            }
          },
          error: function(XMLHttpRequest, textStatus){
            wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
          }
        };
        jQuery.ajax(ajax);
      },
      cart_remove_item: function(line, callback){
        var ajax = {
          type: "POST",
          url: "/cart/change.js",
          data: "quantity=0&line=" + line,
          dataType: "json",
          beforeSend: function(){
            jQuery('.cart_loader_cls_id').show();
          },
          success: function(cart){
            if((typeof callback) === 'function'){
              callback(cart);
            } else{
              wc_theme_source.lib.on_cart_update(cart);
            }
            jQuery('.cart_loader_cls_id').hide();
          },
          error: function(XMLHttpRequest, textStatus){
            wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
          }
        };
        jQuery.ajax(ajax);
      },
      cart_clear_all: function(){
        var ajax = {
          type: "POST",
          url: "/cart/clear.js",
          data: "",
          dataType: "json",
          success: function(cart){
            wc_theme_source.lib.on_cart_update(cart);
          },
          error: function(XMLHttpRequest, textStatus){
            wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
          }
        };
        jQuery.ajax(ajax);
      },
      update_cart_form: function(form){
        var ajax = {
          type: "POST",
          url: "/cart/update.js",
          data: jQuery("#" + form).serialize(),
          dataType: "json",
          beforeSend: function(){
            jQuery('#'+form).find(".cart_btn_class").attr("disabled", true);
          },
          success: function(cart){
            wc_theme_source.lib.on_cart_update(cart);
            jQuery('#'+form).find(".cart_btn_class").attr("disabled", false);
          },
          error: function(XMLHttpRequest, textStatus){
            wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
          }
        };
        jQuery.ajax(ajax);
      }
    }
  }

  jQuery(document).on('click', '.add_to_cart_btn_cls', function(){
    var this_click = $(this).data('click');
    var temp_form_id = jQuery(this).closest('form').attr('id');
    wc_theme_source.lib.addtocart_form(temp_form_id, '', '', this_click);
    return false;
  });

  jQuery(document).on('click', '.cart_add_btn', function(){
    
    
    
    var this_click = $(this).data('click');
    var temp_variant_id = jQuery(this).attr('data-id');
    var temp_qty = 1;
    wc_theme_source.lib.addtocart_product(temp_variant_id, temp_qty, '', this_click);
    return false;
  });

 
//   $('.minus-box').on('click',function(){
//     if(finalprice < 11500){
//       $(this).find('.cart-item-remove-cls').trigger('click');
//     }
//   });


  jQuery(document).on('click', '.upsell-addtocart-btn', function(){
    var this_click = $(this).data('click');
    var temp_variant_id = jQuery(this).attr('data-id');
    var temp_qty = 1;
    wc_theme_source.lib.addtocart_product(temp_variant_id, temp_qty, '', this_click);
    return false;
  }); 


  jQuery(document).ready(function(){
    ajaxCart.load();
  });	


  // ie: Engine.ui.misc();
  $(function() {
    "use strict";
    var Engine = {
      ui: {
        misc: function() {
          $(".theme-drawer-toggle,.cart-close,.cart-drawer-overlay").on('click', function() {
            $("body").toggleClass("CartOpen");
            return false;
          });

          $(".dropdown .dropdown-toggle").on('click', function() {
            $(this).parents(".dropdown").find(".dropdown-options").toggle();          
            $(this).toggleClass('in-active');
            return false;
          });        
          $(".dropdown .dropdown-options a:not(.dropdown-link)").on('click', function() {
            var text = $(this).html();
            $(this).parents(".dropdown").find('.dropdown-toggle span').html(text);
            $(this).parents(".dropdown").find(".dropdown-options").hide();         
          });       
          $(document).bind('click', function(e) {
            var $clicked = $(e.target);
            if (! $clicked.parents().hasClass("dropdown"))
              $(".dropdown .dropdown-options").hide();
            $(".dropdown .dropdown-toggle").removeClass('in-active');
          });
        
          
          $(document).on('click','.QuantityBox .plus', function() { 
            var $qty = $(this).parents('.QuantityBox').find(".QuantityInput");
            var currentVal = parseInt($qty.val(), 10);
            if (1 <= currentVal) {
              $(this).parents('.QuantityBox').find('li.minus-box').removeClass('disabled');
            }
            if (!isNaN(currentVal)) { $qty.val(currentVal + 1);}
            if($(this).hasClass('cart-update')){
              $('input[name="update"]').trigger("click");
            }
          });
          $(document).on('click','.QuantityBox .minus', function() {
            var $qty = $(this).parents('.QuantityBox').find(".QuantityInput");
            var currentVal = parseInt($qty.val(), 10);
            if (currentVal <= 2) {
              $(this).parents('.QuantityBox').find('li.minus-box').addClass('disabled');
            }
            if (!isNaN(currentVal) && currentVal > 1) {$qty.val(currentVal - 1);}
            $('.cart-footer-inner').find('.hide[value="Update Cart"]').trigger('click');
          });     


        }, // end misc
        metisNavMenu: function() {

        },
        stickyHeader: function() {        

        },
        
      }, // end ui
      utils: {
        sliders: function() {
          //  Home Slider
          var slideshow_autorotate = $('ul.slideshow-wrapper').data('autorotate');
          console.log(typeof slideshow_autorotate);
          var slideshow_speed = $('ul.slideshow-wrapper').data('speed');
          $('ul.slideshow-wrapper').slick({
            arrows: true,
            speed: 500,
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            centerMode: false,
            touchMove: true,
            slide: 'li',
            autoplay: slideshow_autorotate,
            autoplaySpeed: slideshow_speed,
            adaptiveHeight: true

          });     
        },
      }, // end utils
    };
    Engine.ui.misc();
    Engine.ui.metisNavMenu();
    Engine.ui.stickyHeader();
    Engine.utils.sliders();
    $(document).on('click','.search-toggle-button',function(e){
      $(this).parents('.search-header').toggleClass('search-open');
    });
    $(document).on('click','.mob_search_label,.mob_serach_icon',function(e){
      $(this).parents('.mob_search_toggle').toggleClass('activesearch');
    });
    $(document).on('keypress','.search-toggle-button',function(e){
      $(this).parents('.search-header').toggleClass('search-open');
    });
    $(document).on('keypress','.mob_search_label,.mob_serach_icon',function(e){
      $(this).parents('.mob_search_toggle').toggleClass('activesearch');
    });
    
     var n = $('ul.featured-collection-slider li').length;
     
    if(n >= 4){
    	n = 4;
    }
   
    
    
    
    $('ul.featured-collection-slider').slick({
      arrows: true,
      dots: false,
      slidesToShow: n,
      slidesToScroll: 1,
      infinite: true,
      centerMode: false,
      touchMove: true,
      slide: 'li',
      autoplay: true,
      autoplaySpeed: 4000,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '125px',
            infinite:true,
            arrows: false,
            dots:true,
            autoplay:true,
            autoplaySpeed: 1000
          }
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '90px',
            infinite:true,
            arrows: false,
            dots:true,
            autoplay:true,
            autoplaySpeed: 4000
          }
        },
        {
          breakpoint: 350,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '50px',
            infinite:true,
            arrows: false,
            dots:true,
            autoplay:true,
            autoplaySpeed: 4000
          }
        }
      ]
    });
    if($(window).width() < 992){
      $('.article_related_products').slick({
        arrows: true,
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        centerMode: false,
        touchMove: true,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '125px',
              infinite:true,
              arrows: false,
              dots:true,
              autoplay:true,
              autoplaySpeed:4000
            }
          },
          {
            breakpoint: 575,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '90px',
              infinite:true,
              arrows: false,
              dots:true,
              autoplay:true,
              autoplaySpeed: 4000
            }
          },
          {
            breakpoint: 350,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '50px',
              infinite:true,
              arrows: false,
              dots:true,
              autoplay:true,
              autoplaySpeed: 4000
            }
          }
        ]
      });
    }
    $('.reviewslider').slick({
      arrows: true,
      dots: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: false,
      centerMode: false,
      touchMove: true,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '125px',
            infinite:true,
            arrows: false,
            autoplay:true,
            autoplaySpeed:4000
          }
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '20%',
            infinite:true,
            arrows: false,
            autoplay:true,
            autoplaySpeed: 4000
          }
        }
      ]
    });
    $('.approch_slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: true,
      arrows: false,
      fade: false,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
            autoplay: true,
            infinite:true,
            variableWidth: true,
            autospeed:4000
          }
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
            autoplay: true,
            infinite:true,
            variableWidth: true,
            autospeed:4000
          }
        }
      ]
    });
    $('.testimonial-main-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      fade: false,
      asNavFor: '.testimonial-logos-slider'
    });
    var testimonialLogoBlocks = $('.testimonial-logos-slider').data('slides');
    if(testimonialLogoBlocks > 7){
    	var testimonialLogoBlocks = 7;  
    }else{
      var testimonialLogoBlocks = 5;
    }
    $('.testimonial-logos-slider').slick({
      slidesToShow: testimonialLogoBlocks,
      slidesToScroll: 1,
      asNavFor: '.testimonial-main-slider',
      dots: false,
      arrows: false,
      centerMode: true,
      centerPadding: '0px',
      focusOnSelect: true,
      infinite: true,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3 ,
            centerPadding: '10%'
          }
        },
        {
          breakpoint: 641,
          settings: {
            slidesToShow: 1,
            centerPadding: '25%'
          }
        }
      ]
    });
    $('.text-columns-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: false,
      dots: false,
      arrows: true,
      centerMode: false,
      centerPadding: '0px',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow:1
          }
        }
      ]
    });
    $('.data_slide_wrap').slick({
      slidesToShow:1,
      slidesToScroll: 1,
      infinite: true,
      dots: false,
      arrows: true,
      centerMode: false,
      centerPadding: '0px'
    });
    
    $('.cart-upsell-slider').slick({
      slidesToShow:2,
      slidesToScroll: 1,
      infinite: false,
      dots: false,
      arrows: true,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            variableWidth: false,
            infinite:true,
            adaptiveHeight: true
          }
        },
        {
          breakpoint: 641,
          settings: {
            variableWidth: false,
            slidesToShow:1,
            infinite:true,
            adaptiveHeight: true
          }
        }
      ]
    });
    
    $('.lab_f_slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      infinite:true,
      variableWidth: true
    });
    $('.blogs-list-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      arrows: false,
      dots: false,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 768,
          settings: 'unslick'
        }
      ]
    });

    $(window).on('resize', function() {
      $('.blogs-list-slider').slick('resize');
    });
    
    $('.related_articles_slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      arrows: false,
      dots: false,
      variableWidth: true,
      slide: '.slider-slide',
      responsive: [
        {
          breakpoint: 768,
          settings: 'unslick'
        }
      ]
    });
    
    $('.text-columns-grid-slider').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      mobileFirst: false,
      arrows: true,
      dots: false,
      variableWidth: false,
      slide: '.text-columns-grid-cls',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ]
    });

    $(window).on('resize', function() {
      $('.related_articles_slider').slick('resize');
    });
    /*$('.ajax-cart-upsell-slider').slick({
    slidesToShow:1,
    slidesToScroll: 1,
    infinite: false,
    dots: false,
    arrows: true,
    variableWidth: false
  });*/
    $('.th_product_parent_cls .sd_title').matchHeight({
      property: 'height'
    });
    $('.th_product_parent_cls .meta-sub-text').matchHeight({
      property: 'height'
    });


    $('.th_product_parent_cls .yotpo_grid').matchHeight({
      property: 'height'
    });


    if($('#ajax_cart_upsell').length > 0){
      var upsell_html = $('#ajax_cart_upsell').html();
      var product_handle = 'upsell-handle'+$('.wc_main_pro').data('product-handle');
      localStorage.setItem(product_handle, upsell_html);
    }
    if($(window).width() > 767){
      var topPercentage = 75;
    }else{
      var topPercentage = 50;
    }

    if($('.hero-banner--article').length > 0){
      var ImageHeight = $('.hero-banner--article').outerHeight();
      var SectionTop = (topPercentage * ImageHeight) / 100;
      SectionTop = Math.round(SectionTop);
      $('.section-standard-wrap.article-header').css('padding-bottom',SectionTop+"px");
      $('.article-content-wrap').css('margin-top', '-'+SectionTop+''+"px");
    }

    /* Lining animation */
    var pageLength = $('.template-index').length;
    if(pageLength > 0 && $('.richanimation').length > 0){
      function multilineTextUnderline() {
        var text = document.querySelector('.line_text');
        var words = text.innerText.split(' ');
        var div = document.querySelector('.rich-text-content');

        var initialText = text.innerText;
        var widths = [];
        var lineHeight = parseInt($(text).css('line-height'), 10);
        var firstWord = 0;
        text.innerText = words[0];
        var currentHeight = text.offsetHeight;

        $('.rich-text-content span').remove();
        $('.rich-text-content br').remove();

        function getWidths() {
          words.forEach(function(word, i) {
            text.innerText = words.slice(firstWord, i + 1).join(' ');
            if(currentHeight < text.offsetHeight) {
              text.innerText = words.slice(firstWord, i).join(' ');
              widths.push(text.offsetWidth);
              firstWord = i;

              var newSpan = document.createElement('span');
              newSpan.innerText = text.innerText;
              div.appendChild(newSpan);
              div.appendChild(document.createElement('br'));

              if(i === words.length - 1) {
                text.innerText = words[i];
                widths.push(text.offsetWidth);

                var newSpan = document.createElement('span');
                newSpan.innerText = text.innerText;
                div.appendChild(newSpan);
                div.appendChild(document.createElement('br'));
              }
            } else if(i === words.length - 1) {
              widths.push(text.offsetWidth);

              var newSpan = document.createElement('span');
              newSpan.innerText = words.slice(firstWord).join(' ');
              div.appendChild(newSpan);
              div.appendChild(document.createElement('br'));
            }
          });
        }

        getWidths();
        text.innerText = initialText;
        var controlWidths = [];

        [].forEach.call(document.querySelectorAll('.rich-text-content span'), function(span) {
          controlWidths.push(span.offsetWidth);
        });

        //rendering underlines
        var container = document.querySelector('.richanimation');
        var containerWidth = container.offsetWidth;
        var lines = [];
        $('.line').remove();

        widths.forEach(function(lineWidth, i) {
          var line = document.createElement('div');
          line.classList.add('line');
          line.style.top = lineHeight * (i + 1) - 2 + 'px';

          lines.push(line);
        });

        lines.forEach(function(line) {  
          container.appendChild(line);
        });

        container.addEventListener('mouseenter', function() {
          lines.forEach(function(line, i) {  
            line.style.width = widths[i] + 'px';
            line.style.left = 0;
            line.style.right = 'auto';
          });
        });
        container.addEventListener('mouseleave', function() {
          lines.forEach(function(line, i) {  
            line.style.width = 0;
            line.style.left = 'auto';
            line.style.right = containerWidth - widths[i] + 'px';
          });
        });
        $('.rich-text-section .rich-text-content h3').hide();
        $('.rich-text-section .rich-text-content').css('max-width','100%');
      }

      multilineTextUnderline();

      window.addEventListener('resize', function() {

        multilineTextUnderline();
      });
    }

    /* Ens Lining animation */
    
    getDeviseOs();
  });
  $(document).on('change','.wc_select_selector',function(e){
    var selectedValue = $(this).val();
    $('.swatch-input-cls[value="'+selectedValue+'"]').trigger("click");
  });
  $(document).on('click','.sticky_add_to_cart',function(e){
    $('#addtocart_btn_id').trigger("click");
  });
  $(document).on('click', '.accordion-trigger', function(e) {
    $(this).parents('.accordion-grid').siblings().find('.accordion-content').slideUp();
    $(this).parents('.accordion-grid').siblings().find('.accordion-trigger').removeClass('active');
    $(this).next('.accordion-content').slideToggle();
    $(this).toggleClass('active')
  });
  $(document).on('click','button[data-address-toggle]',function(e){
    var dataForm = $(this).data('address-toggle');
    $('div['+dataForm+']').slideToggle('hide');
  });
  /*---- Tabs------*/
  $(document).on('click', 'ul.tabs li', function(e) {
    var tab_id = $(this).attr('data-tab');
    $('ul.tabs li').removeClass('current');
    $('.tab-content').removeClass('current');

    $(this).addClass('current');
    $("#"+tab_id).addClass('current');
    if($('.data_slide_wrap').length>0){
      $('.data_slide_wrap').slick('refresh');
    }
  });
  /*---- Popup------*/
  $(document).on('click', '.poupupbtn', function(e) {
    var thisattr = $(this).data('id');
    $("#"+thisattr).addClass('model-open');
    $('body').addClass('bodymodal');
  }); 
  $(".close-btn, .bg-overlay").click(function(){
    $(".custom-model-main").removeClass('model-open');
    $('body').removeClass('bodymodal');
  });
  /*----Page Team--*/
  if($('.team_nav').length>0){
    $('.team_nav a:not(.redirect_link_cls)').bind('click', function(e) {
      e.preventDefault();
      var target = $(this).attr("href");
      var totalOffset = $('.header_outer').outerHeight() + $('.team_nav').outerHeight();
      $('html, body').stop().animate({
        scrollTop: $(target).offset().top - totalOffset
      }, 20/*, function() {
        location.hash = target;
      }*/);
      if($(this).parents('.blog_nav_trigger').find('.blog_nav_trigger_btn').hasClass('active_cls')){
        $(this).parents('.blog_nav_trigger').find('.blog_nav_trigger_btn').removeClass('active_cls');
        $(this).parents('.blog_nav_list').slideUp();
      }
      return false;
    });
    $(window).scroll(function() {
      var totalOffset = $('.header_outer').outerHeight() + $('.team_nav').outerHeight();
      var scrollDistance = $(window).scrollTop() + totalOffset;
      $('.teamsection').each(function(i) {
        if ($(this).position().top <= scrollDistance) {
          $('.team_nav li.active').removeClass('active');
          $('.team_nav li').eq(i).addClass('active');
        }
      });
    }).scroll();
  }
  if($('.page-contact').length>0){
    $(function() {
      $(".contactform").validate({
        rules: {
          "contact[name]": "required",
          "contact[email]": {
            required: true,          
            email: true
          }
        },
        messages: {
          "contact[name]": "Please enter a name.",
          "contact[email]": "Please enter a valid email address."
        },
        errorPlacement: function(error, element) {
          error.appendTo('.errordiv');
        },
        submitHandler: function(form) {
          form.submit();
        }
      });
    });
  }
  jQuery(function($) {
    var doAnimations = function() {
      var offset = $(window).scrollTop() + $(window).height(),
          $animatables = $('.animatable');
      if ($animatables.length == 0) {
        $(window).off('scroll', doAnimations);
      }
      $animatables.each(function(i) {
        var $animatable = $(this);
        //console.log($animatable.offset().top + $animatable.height(),offset)
        if (($animatable.offset().top) < offset) {
          $animatable.removeClass('animatable').addClass('animated');
          setTimeout(function(){
            $animatable.addClass('animated-finish');
          },3500);
        }
      });
    };
    $(window).on('scroll', doAnimations);
    $(window).trigger('scroll');
  });
  jQuery(function($) {
    var faqAnimations = function() {
      var offsetfaq = $(window).scrollTop() + $(window).height(),
          $animatablesfaq = $('.animatable_faq');
      if ($animatablesfaq.length == 0) {
        $(window).off('scroll', faqAnimations);
      }
      $animatablesfaq.each(function(i) {
        var $animatablefaq = $(this);
        //console.log($animatable.offset().top + $animatable.height(),offset)
        if (($animatablefaq.offset().top + 100) < offsetfaq) {
          $animatablefaq.removeClass('animatable_faq').addClass('animated_faq');
        }
      });
    };
    $(window).on('scroll', faqAnimations);
    $(window).trigger('scroll');
  });
  if($('.form_dropdowncls').length>0){
    $('.form_dropdowncls').each(function(e){
      $(this).find('.dropdown-options li').on('click',function(e){          
        var anchorvalue = $(this).data('value');
        $(this).parents('.form_dropdowncls .dropdown-options').hide();
        $(this).parents('.form_dropdowncls .dropdown').find('.form-fields').val(anchorvalue);
      });
    });
  }
  /*-----tema Accordian---*/
  if($('.teamcolumn').length>0){
    $(document).on('click', '.team_top', function(e) {
      $(this).parents('.teamcolumn').siblings().find('.team_content').slideUp();
      $(this).parents('.teamcolumn').siblings().removeClass('active');
      $(this).next('.team_content').slideToggle();
      $(this).parents('.teamcolumn').toggleClass('active')
    });
  }
  /*-----Footer Accordian---*/
  $('.footer_mob_dropdown .footer-title').on('click',function(e){
    $(this).next('.footer-menu-list').slideToggle();
    $(this).toggleClass('active');
  });
  /*---Mobile Navigation---*/
  $(document).on('click','.mega_nav_link', function(e) {
    e.preventDefault(e);
    $(this).next('.mob_drop_nav').slideToggle().parent().siblings().find('.mob_drop_nav').slideUp();
    $(this).toggleClass('active').parent().siblings().find('.mega_nav_link').removeClass('active');
  });
  $(document).on('click','.menu_btn', function(e) {
    $('body').toggleClass('opennav');
  });
  var headerheight = $('.header_outer').innerHeight();
  $('.mob_navwrap').css({ "top": headerheight});
  //$('.team_nav, .blog_nav').css({ "top": headerheight});  
  $(document).on('click','.account_nav_btn', function(e) {
    $('.account-sidebar-links').slideToggle();
    $(this).toggleClass('active');
  });
  /*--- sticky Nav---*/
  $(window).scroll(function() {
    var headerheight = $('.header_outer').outerHeight();  
    $('.team_nav, .blog_nav, .pro_sticky, #shopify-section-lab-notes-filter, #shopify-section-research-room-filter, #shopify-section-innovation-filter, #about_team_nav_id').css('top',headerheight+"px");
    if ($(this).scrollTop() >= 1) {
      $('body').css('padding-top',headerheight);
      $('.header_outer').addClass('stickyHeader');      
    } else {
      $('.header_outer').removeClass('stickyHeader'); 
      $('body').css('padding-top','0px');
    }
  });

  $(window).on('load', function() {
    if(typeof(Storage) !== "undefined") {
      if(sessionStorage.newsletter_popup == 'true'){
      }
      else{
        sessionStorage.newsletter_popup = 'true';
        setTimeout(function () {
          if( $.cookie("newsletter") == 'hidenewsletter' ){
            /* $("#newsletter-popup").modal('show');*/
          }
          else{
            $("#newsletter-popup").show();
            $.cookie("newsletter", "hidenewsletter");
          }
        }, 2000);
      }
    }
  });
  $(document).on('click','#newsletter-popup .custom-popup-close',function(){
    $("#newsletter-popup").hide();
  });
  $(window).on('load', function() {
    if(typeof(Storage) !== "undefined") {
      if(sessionStorage.cookie_popup == 'true'){
      }
      else{
        sessionStorage.cookie_popup = 'true';
        setTimeout(function () {
          if( $.cookie("cookie_acc") == 'hidecookiepopup' ){
            /* $("#newsletter-popup").modal('show');*/
          }
          else{
            $("#cookies-acceptance-popup").show();
            $.cookie("cookie_acc", "hidecookiepopup");
          }
        }, 2000);
      }
    }
  });
  $(document).on('click','#cookies-acceptance-popup .custom-popup-close',function(){
    $("#cookies-acceptance-popup").hide();
  });
  $(document).on('click', '.cart-upsell-addtocart-btn', function(){
    var btn_this = $(this);
    var product_id = btn_this.data('id');
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {quantity:1, id:product_id},
      dataType: 'json',
      beforeSend: function(){
        btn_this.addClass('disabled_button_cls');
      },
      success: function(cart){
        $(this).removeClass('disabled_button_cls');
        location.reload();
      },
      error: function(XMLHttpRequest, textStatus){
        console.log(XMLHttpRequest);
      }
    });
  });
  $(document).on('change','.swatch-input-cls',function(e){
    var productPrice = $('#productSelect').find(':selected').data('price');
    var productImage = $('#productSelect').find(':selected').attr('data-image');
    if(productPrice != '' || productPrice != null || productPrice != undefined){
      $('.pro_price .money').text(productPrice)
    }
    if(productImage != '' || productImage != null || productImage != undefined){
      var dataIndex = Number($('.product-single__media-wrapper[data-image="'+productImage+'"]').attr('data-slick-index'));
      $('.product-single-slider').slick('slickGoTo', dataIndex)
    }
  });
  function getDeviseOs(){
    os_types = window.navigator.userAgent;
    os = "Windows";
    if(os_types.indexOf("Mac") != -1){
      os = "MAC";
    }else if(os_types.indexOf("Linux") != -1) {
      os = "Linux";
    }
    if (navigator.userAgent.match(/Android/i)) os = "Android";
    if(os == 'MAC'){
      $('body').addClass('mac-os-cls');
    }
    return os
  }
  $(document).on('click','.blog_nav_trigger_btn',function(e){
    $(this).next('.blog_nav_list').slideToggle();
    $(this).toggleClass('active_cls');
  });
  $(document).on('click','.article_load_more_btn',function(e){
    e.preventDefault();
    $('.blog_article_detail').css('max-height','initial');
    $(this).hide();
  });

  